module.exports = __webpack_public_path__ + "static/cigna-logo-2206a4c761ec4a82ffb10fe91575fe97.png";